import React from "react";
import PropTypes from "prop-types";
import Footer from "../Footer/Footer";
function Layout({ children }) {
  return (
    <div>
      <main>{children}</main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
